import { DRUPAL_NODE_DISPLAY } from '@commons/types/drupal';
import type {
  DrupalImage as DrupalImageType,
  DrupalLink,
  DrupalNodePage,
  DrupalTerm,
} from '@commons/types/drupal';

import MemberNodeCard from './Card';
import MemberNodeLabel from './Label';

/**
 * Type definition for a Drupal member role term.
 */

export type MemberRole = DrupalTerm & {
  label: string;
};

/**
 * Type definition of a Member node properties.
 */

export type MemberNodeProps = DrupalNodePage & {
  bio: string;
  role: MemberRole[];
  position: string;
  location?: string;
  headshot: DrupalImageType;
  linkedIn?: DrupalLink;
};

/**
 * Member node component.
 *
 * Renders a component based on the display type.
 */

export const MemberNode = (props: MemberNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <MemberNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <MemberNodeCard {...props} />;
  }
};

export default MemberNode;
